import { render, staticRenderFns } from "./ReteCanvasMenu.vue?vue&type=template&id=252a643e&scoped=true&"
import script from "./ReteCanvasMenu.vue?vue&type=script&lang=js&"
export * from "./ReteCanvasMenu.vue?vue&type=script&lang=js&"
import style0 from "./ReteCanvasMenu.vue?vue&type=style&index=0&id=252a643e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252a643e",
  null
  
)

export default component.exports